// Reading and writing the payment records behind the payments report
// (api/fee-slip-payments.js). The whole firm's payments are read at once: the report shows
// one period, but each invoice row also has to show what has already been paid against it.

export async function fetchFeeSlipPayments(brand, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(`/api/fee-slip-payments?brand=${encodeURIComponent(brand)}`, {
    credentials: "include",
    cache: "no-store",
  });
  if (!response.ok) throw new Error(`Payments returned ${response.status}`);
  const payload = await response.json();
  return Array.isArray(payload) ? payload : [];
}

export async function recordFeeSlipPayment(payment, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl("/api/fee-slip-payments", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payment),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || `The payment could not be recorded (${response.status})`);
  return payload;
}

export async function voidFeeSlipPayment(id, fetchImpl = globalThis.fetch) {
  const response = await fetchImpl(`/api/fee-slip-payments?id=${encodeURIComponent(id)}`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ void: true }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.error || `The payment could not be voided (${response.status})`);
  return payload;
}
